/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import Vue from 'vue';
import Moment from '@/plugins/moment';
import Debounce from '@/plugins/debounce';

/**
 * Plugins entry point.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

// register moment plugin
Vue.use(Moment);

// register debounce plugin
Vue.use(Debounce);
